import { ReactElement } from 'react';
import {
  Modal,
  UnorderedList,
  ListItem,
  Link,
  ModalBody,
} from 'carbon-components-react';
import { ThumbsDown32, ThumbsUp32, Help32 } from '@carbon/icons-react';
import { segmentsTracking } from '../lib/tracker';
import { FormattedMessage } from 'react-intl';
import '../style/userStuckModal.scss';

export interface userStuckModalProperties {
  setShowResponseModal: React.Dispatch<React.SetStateAction<boolean>>;
  showResponseModal: boolean;
  textResponse: string[];
  primaryButton: string;
  modalTitle: string;
  tracking: string[];
  messages: any;
  setThumbsUp: React.Dispatch<React.SetStateAction<boolean>>;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setShowFeedbackModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const UserStuckModal = ({
  showResponseModal: showModal,
  setShowResponseModal: setShowModal,
  textResponse,
  primaryButton,
  modalTitle,
  tracking,
  messages,
  setThumbsUp: setThumbsUp,
  setDrawerOpen: setDrawerOpen,
  setShowFeedbackModal: setShowFeedbackModal,
}: userStuckModalProperties): ReactElement => {
  const onLinkClick = () => {
    setDrawerOpen(true);
    setShowModal(false);
  };
  const render = (
    <div className="bx--grid UserStuckModal">
      <Modal
        open={showModal}
        passiveModal
        modalHeading={modalTitle}
        primaryButtonText={primaryButton}
        onRequestClose={() => {
          setShowModal(false);
        }}
        onRequestSubmit={() => {
          setShowModal(false);
        }}
      >
        <ModalBody hasForm className="ModalBody">
          <div className="bx--row ">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <div className="type1">{textResponse[0]}</div>
              <br />
              <UnorderedList>
                <ListItem>
                  <span className="page_body_2 alignText">
                    {textResponse[1]}
                  </span>
                  <Help32
                    tabIndex="0"
                    className="colorBlue spaceLeft spaceTop"
                    onClick={() => {
                      segmentsTracking('CTA Clicked', {
                        pageTitle: tracking[0],
                        object: tracking[1],
                        productTitle: tracking[2],
                        pageUrl: tracking[3],
                        resultValue: 'CTA clicked',
                        CTA: 'I need specific pricing information CTA',
                        location: 'Estimator',
                        action: '',
                        field: '',
                      });
                      onLinkClick();
                    }}
                  />
                </ListItem>
                <br />
                <ListItem>
                  <span className="page_body_2 alignText">
                    {textResponse[2]}
                  </span>
                  <ThumbsUp32
                    className="colorBlue spaceLeft spaceTop"
                    tabIndex="1"
                    aria-label="add"
                    onClick={() => {
                      segmentsTracking('CTA Clicked', {
                        pageTitle: tracking[0],
                        object: tracking[1],
                        productTitle: tracking[2],
                        pageUrl: tracking[3],
                        resultValue: 'CTA clicked',
                        CTA: 'Thumbs up clicked',
                        location: 'Estimator',
                        action: '',
                        field: '',
                      });
                      setThumbsUp(true);
                      setShowFeedbackModal(true);
                      setShowModal(false);
                    }}
                  />{' '}
                  <span className="alignText page_body_2">
                    <FormattedMessage {...messages.feedBackHelpfull} />
                  </span>
                  <ThumbsDown32
                    className="spaceLeft spaceTop"
                    tabIndex="2"
                    onClick={() => {
                      segmentsTracking('CTA Clicked', {
                        pageTitle: tracking[0],
                        object: tracking[1],
                        productTitle: tracking[2],
                        pageUrl: tracking[3],
                        resultValue: 'CTA clicked',
                        CTA: 'Thumbs down clicked',
                        location: 'Estimator',
                        action: '',
                        field: '',
                      });
                      setThumbsUp(false);
                      setShowFeedbackModal(true);
                      setShowModal(false);
                    }}
                  />{' '}
                  <span className="alignText page_body_2">
                    <FormattedMessage {...messages.feedBackNotHelpfull} />
                  </span>
                </ListItem>
                <br />
              </UnorderedList>
              <br />
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
  return render;
};
